import { IChatUserDto, IMessageDto, MessageTypeEnum } from '@/Models/Chat'
import React from 'react'
import TextMessage from './TextMessage';
import { useUserData } from '@/Hooks/useUserData';
import OfferMessage from './OfferMessage';
import LocationMessage from './LocationMessage';

type Props = {
  message: IMessageDto;
  chatData: IChatUserDto;
}

const MessageItem = ({ message, chatData }: Props) => {
  const userData = useUserData()!;
  
  let Item = null;
  switch (message.messageType) {
    case MessageTypeEnum.TEXT: {
      Item = TextMessage;
      break;
    }
    case MessageTypeEnum.OFFER: {
      Item = OfferMessage;
      break;
    }
    case MessageTypeEnum.LOCATION: {
      Item = LocationMessage;
      break;
    }
  }

  if(!Item) {
    return null
  }

  return (
    <Item data={message} isSender={(userData.id === message.sender)} chatData={chatData} />
  )
}

export default MessageItem;
